//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  
  import {
    agreementInfo,
    agreementInfoSubmit,
    userInfo
  } from './service/index'
  import {
    getCookie
  } from './utils/storage'
  import {
    mapState,
    mapMutations
  } from 'vuex'
  import watermark from '@/components/watermark.vue'
  import {
    setTimeout
  } from 'timers';
  let Base64 = require('js-base64').Base64;
  export default {
    name: 'App',
    data() {
      return {
      
      }
    },
    components: {
      watermark
    },
    mounted() {
      
     
      this.setTempName(Base64.decode(getCookie("user_name")))
    },
    computed: {
      ...mapState([
        "global", "rule", "tempName"
      ]),
    },
    methods: {
      
      async closeAgreement() {
        let cid = !!this.$route.query.cid ? this.$route.query.cid : -1
        const res = await agreementInfoSubmit(cid);
        if (res.status === 0) {
          this.toggleAgreement(false)
          window.location.reload()
        }
      },
      closeAgreementDirect() {
        this.toggleAgreement(false)
      },
      closeRule() {
        this.hideRule()
      },
      ...mapMutations({
        toggleAgreement: 'TOGGLE_AGREEMENT',
        hideRule: 'HIDE_RULE',
        setTempName: 'SET_TEMPNAME'
      })
    }

  }




// WEBPACK FOOTER //
// ./src/App.vue